/**
 * Best Seller flame badge -- keeps it in sync when a shopper swaps colour on a
 * product card (<pcard-sibling-swatches>).
 *
 * Best Seller (tag "bestseller") shares the bottom-right flame badge with
 * Trending (tag__hot_*) and wins over it -- see card-product.liquid. The
 * swatch script's updateTrendingBadge() only knows about tag__hot_, so this
 * wraps it: after it runs, a colour tagged "bestseller" gets the flame badge
 * reading "Best Seller" (created if the swap removed it).
 *
 * It also keeps the top-left New / Restocked badge in sync with the colour a
 * shopper swaps to (Oct 2026). Each colour dot carries data-swap-status
 * (soldout / sale / new / restocked / blank -- see 'pcard-top-status'), worked
 * out server-side with the same rules as card-product.liquid. When a dot is
 * picked, any New / Restocked badge is removed and re-added only if that
 * colour has one; Sold out and Sale are still handled by the swatch script.
 *
 * Loaded from card-product.liquid (once per card), so it guards itself to
 * patch only once.
 */
(function () {
  if (window.__kkBestsellerBadgePatched) return;
  window.__kkBestsellerBadgePatched = true;

  function syncTopStatus(card, status) {
    var wrapper = card.querySelector('.product-card__image-wrapper');
    if (!wrapper) return;
    var container = card.querySelector('.product-card__badge:not(.product-card__badge--trending)');
    if (container) {
      container.querySelectorAll('.f-badge--new').forEach(function (el) {
        el.remove();
      });
    }
    var showStatus = status === 'new' || status === 'restocked';
    if (showStatus) {
      if (!container) {
        container = document.createElement('div');
        container.className = 'product-card__badge';
        wrapper.appendChild(container);
      }
      var badge = document.createElement('span');
      badge.className = status === 'new' ? 'f-badge f-badge--new' : 'f-badge f-badge--new f-badge--restocked';
      badge.textContent = status === 'new' ? 'New' : 'Restocked';
      container.insertBefore(badge, container.firstChild);
    }
    if (!container) return;
    // Only one top-left badge shows (card-product.liquid): hide any other
    // tag__ badge while New / Restocked is showing, bring it back otherwise.
    container.querySelectorAll('.f-badge').forEach(function (el) {
      if (el.classList.contains('f-badge--new') || el.classList.contains('f-badge--soldout') || el.classList.contains('f-badge--sale')) return;
      el.style.display = showStatus ? 'none' : '';
    });
    if (container.children.length === 0) container.remove();
  }

  customElements.whenDefined('pcard-sibling-swatches').then(function () {
    var Cls = customElements.get('pcard-sibling-swatches');
    if (!Cls) return;

    if (Cls.prototype.setCurrent) {
      var originalSetCurrent = Cls.prototype.setCurrent;
      Cls.prototype.setCurrent = function (activeLink) {
        originalSetCurrent.call(this, activeLink);
        var card = this.closest('.product-card');
        if (!card || !activeLink || !activeLink.hasAttribute('data-swap-status')) return;
        syncTopStatus(card, (activeLink.getAttribute('data-swap-status') || '').trim());
      };
    }

    if (!Cls.prototype.updateTrendingBadge) return;
    var original = Cls.prototype.updateTrendingBadge;

    Cls.prototype.updateTrendingBadge = function (card, wrapper, product) {
      original.call(this, card, wrapper, product);

      var tags = (product && product.tags) || [];
      if (tags.indexOf('bestseller') === -1) return;

      var container = card.querySelector('.product-card__badge--trending');
      if (!container) {
        container = document.createElement('div');
        container.className = 'product-card__badge product-card__badge--trending';
        var newBadge = document.createElement('span');
        newBadge.className = 'f-badge f-badge--hot f-badge--icon';
        var newIcon = document.createElement('span');
        newIcon.className = 'f-badge__icon';
        newIcon.setAttribute('aria-hidden', 'true');
        newIcon.textContent = '\u{1F525}';
        newBadge.appendChild(newIcon);
        container.appendChild(newBadge);
        wrapper.appendChild(container);
      }

      var badge = container.querySelector('.f-badge--hot');
      var icon = badge && badge.querySelector('.f-badge__icon');
      if (!icon) return;
      while (icon.nextSibling) icon.nextSibling.remove();
      badge.appendChild(document.createTextNode('Best Seller'));
    };
  });
})();
